import React from 'react';
import type { FieldInputProps, FormikProps } from 'formik';
import { TickedCheckbox, UntickedCheckbox } from 'src/assets/images';
import './checkbox.scss';

interface CheckboxProps<T> {
  field: FieldInputProps<boolean>;
  form: FormikProps<T>;
  tealiumEvent?: () => void;
  automationid?: string;
  checkboxText?: string | React.ReactNode;
  checkboxTextStyle?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  isLightMode?: boolean;
  onChecked?: () => void;
}

export default function Checkbox<T extends object>({
  field,
  form,
  isLightMode,
  fullWidth,
  ...props
}: CheckboxProps<T>) {
  const isDisabled = props.disabled || form?.initialStatus?.initialDisabled?.[field.name];
  const { automationid, checkboxText, checkboxTextStyle, onChecked, ...rest } = props;

  const newProps = {
    ...rest,
    disabled: isDisabled,
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    if (onChecked) {
      onChecked();
    }
  };

  return (
    <div
      className={`Checkbox ${isLightMode ? 'light-mode' : ''} ${isDisabled ? 'disabled' : ''}  ${
        field.value ? 'ticked' : ''
      }`}
    >
      <div className={`checkbox-label ${fullWidth ? 'full-width' : ''}`}>
        <input
          id={field.name}
          type="checkbox"
          className="is-hidden"
          checked={field.value}
          name={field.name}
          onChange={onChange}
          onBlur={field.onBlur}
          {...newProps}
          automationid={automationid}
        />

        <label htmlFor={field.name}>
          <img src={field.value ? TickedCheckbox : UntickedCheckbox} />
        </label>

        <span
          className={`checkbox-label-contents ${checkboxTextStyle || ''} ${
            fullWidth ? 'full-width' : ''
          }`}
        >
          {typeof checkboxText === 'function' ? checkboxText() : checkboxText}
        </span>
      </div>
    </div>
  );
}
